// extracted by mini-css-extract-plugin
module.exports = {"list":"OversiktList_list__4mgRy"};